var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.125 11.525C22.8625 11.525 21.9375 9.92504 23.0625 7.96254C23.7125 6.82504 23.325 5.37504 22.1875 4.72504L20.025 3.48754C19.0375 2.90004 17.7625 3.25004 17.175 4.23754L17.0375 4.47504C15.9125 6.43754 14.0625 6.43754 12.925 4.47504L12.7875 4.23754C12.225 3.25004 10.95 2.90004 9.9625 3.48754L7.8 4.72504C6.6625 5.37504 6.275 6.83754 6.925 7.97504C8.0625 9.92504 7.1375 11.525 4.875 11.525C3.575 11.525 2.5 12.5875 2.5 13.9V16.1C2.5 17.4 3.5625 18.475 4.875 18.475C7.1375 18.475 8.0625 20.075 6.925 22.0375C6.275 23.175 6.6625 24.625 7.8 25.275L9.9625 26.5125C10.95 27.1 12.225 26.75 12.8125 25.7625L12.95 25.525C14.075 23.5625 15.925 23.5625 17.0625 25.525L17.2 25.7625C17.7875 26.75 19.0625 27.1 20.05 26.5125L22.2125 25.275C23.35 24.625 23.7375 23.1625 23.0875 22.0375C21.95 20.075 22.875 18.475 25.1375 18.475C26.4375 18.475 27.5125 17.4125 27.5125 16.1V13.9C27.5 12.6 26.4375 11.525 25.125 11.525ZM15 19.0625C12.7625 19.0625 10.9375 17.2375 10.9375 15C10.9375 12.7625 12.7625 10.9375 15 10.9375C17.2375 10.9375 19.0625 12.7625 19.0625 15C19.0625 17.2375 17.2375 19.0625 15 19.0625Z",
    fill: "#161F28"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountSetting);
export default __webpack_public_path__ + "static/media/account-setting.cf76ecab819216f198348885f02fbd4a.svg";
export { ForwardRef as ReactComponent };